module.exports = __webpack_public_path__ + "files/c7b1f26c59130a66e3366338aa76482e.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/apple-touch-icon-152x152.png
// module id = 1248
// module chunks = 76